const controlsSelector = '[data-video-controls]';
const bindings = new WeakMap();

function controlsWithin(root) {
  return [...(root.matches?.(controlsSelector) ? [root] : []), ...root.querySelectorAll(controlsSelector)];
}

function initialise(root = document) {
  controlsWithin(root).forEach((controls) => {
    if (bindings.has(controls)) return;
    const container = controls.closest('[data-video-container], [data-slide], .main-product__media-single');
    const video = container?.querySelector('video');
    if (!video) return;
    const controller = new AbortController();
    bindings.set(controls, controller);
    controls.dataset.videoControlsInitialised = 'true';
    video.controls = false;
    const play = controls.querySelector('[data-video-play-pause]');
    const rewind = controls.querySelector('[data-video-rewind]');
    const mute = controls.querySelector('[data-video-mute]');
    const listen = (target, event, handler) => target?.addEventListener(event, handler, {signal: controller.signal});
    const syncPlay = () => {
      const paused = video.paused || video.ended;
      if (!play) return;
      play.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      play.querySelector('[data-icon-pause]')?.toggleAttribute('hidden', paused);
      play.querySelector('[data-icon-play]')?.toggleAttribute('hidden', !paused);
    };
    const syncMute = () => {
      if (!mute) return;
      mute.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      mute.querySelector('[data-icon-sound-off]')?.toggleAttribute('hidden', !video.muted);
      mute.querySelector('[data-icon-sound-on]')?.toggleAttribute('hidden', video.muted);
    };
    const safePlay = () => {
      const managed = video.closest('viewport-video');
      const playback = managed
        ? customElements.whenDefined('viewport-video').then(() => managed.requestPlay())
        : video.play();
      return playback?.catch(syncPlay);
    };
    const pauseVideo = () => {
      const managed = video.closest('viewport-video');
      if (typeof managed?.requestPause === 'function') managed.requestPause();
      else video.pause();
    };
    listen(play, 'click', () => video.paused ? safePlay() : pauseVideo());
    listen(rewind, 'click', () => {
      if (video.readyState > 0) video.currentTime = Math.max(0, video.currentTime - 5);
    });
    listen(mute, 'click', () => {
      video.muted = !video.muted;
      if (!video.muted) {
        video.removeAttribute('muted');
        safePlay();
      }
      syncMute();
    });
    ['play', 'pause', 'ended', 'error'].forEach(event => listen(video, event, syncPlay));
    listen(video, 'volumechange', syncMute);
    syncPlay();
    syncMute();
  });
}

function destroy(root) {
  controlsWithin(root).forEach((controls) => {
    bindings.get(controls)?.abort();
    bindings.delete(controls);
    delete controls.dataset.videoControlsInitialised;
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), {once: true});
else initialise();
document.addEventListener('shopify:section:load', event => initialise(event.target));
document.addEventListener('shopify:section:unload', event => destroy(event.target));

export {initialise as i, destroy as d};
